import "../styles/pageStyles/lazy-loading.css"
let LazyLoading = ()=>{
    return (
        <div className="loading-container">
            <div className="loading-track">
                <div className="loading-circle"></div>
            </div>
        </div>
    );
}

export default LazyLoading;